import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import CustomersListItem from '../containers/CustomersListItem';

const CustomersList = ({ customers, showBarber }) => {
  if (isEmpty(customers)) {
    return <div>No clients on a waiting list for selected day.</div>;
  }

  return (
    <div>
      <h2 className="c-heading u-mb-">Waiting clients:</h2>
      <ol className="u-pl-">
        {customers.map(customer => (
          <CustomersListItem customer={customer} key={customer.id} showBarber={showBarber} />
        ))}
      </ol>
    </div>
  );
};
CustomersList.propTypes = {
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  ),
  showBarber: PropTypes.bool,
};
CustomersList.defaultProps = {
  customers: [],
  showBarber: false,
};

export default CustomersList;
